export const TRIPS_PAGE_SIZE = 4;

/** Limite de velocidade acima do qual um trecho é considerado excesso de velocidade. */
export const OVER_SPEED_LIMIT_KMH = 110;

export const VEHICLE_LIST_BATCH_SIZE = 10;

export const FILTER_OPTIONS: { id: string; label: string }[] = [
	{ id: "positions", label: "Posições" },
	{ id: "trips", label: "Viagens" },
];
